import { Reducer } from "redux";

import { SSO_Refresh_Token_ActionDispatchTypes } from "../constants/Sso";
import { SSO_Refresh_ActionTypes } from "../models/DispatchTypes/Sso";
import { RefreshedTokenResponse } from "../models/Api/Sso";

const initialState: RefreshedTokenResponse = {
  loading: false,
  response: null,
  error: null,
};

const RefreshedTokenReducer: Reducer<
  RefreshedTokenResponse,
  SSO_Refresh_ActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SSO_Refresh_Token_ActionDispatchTypes.SSO_REFRESH_TOKEN_RESET: {
      return initialState;
    }
  }
  return state;
};

export default RefreshedTokenReducer;
